import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { createUseStyles } from 'react-jss'

import { getProductTheme } from 'lib/CheckProduct'

const useStyles = createUseStyles({
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    padding: '20px 50px'
  }
})

function FullScreenModalHeader({ children, className }) {
  const classes = useStyles()

  return (
    <header className={classNames(classes.header, className)}>{children}</header>
  )
}

FullScreenModalHeader.propTypes = {
  background: PropTypes.oneOf(Object.keys(getProductTheme().colors)),
  className: PropTypes.string,
  variant: PropTypes.oneOf(['compact', 'default'])
}

FullScreenModalHeader.defaultProps = {
  background: 'primary',
  className: null,
  variant: 'default'
}

export default FullScreenModalHeader
